// Component ID helpers (deterministic + optional random variants)
// --------------------------------------------------------------
// Original naming restored: makeMenuComponentId, makeBaseComponentId

function hash10(seed: string) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = (h * 33 + seed.charCodeAt(i)) >>> 0;
    return (h.toString(36) + "0000000000").slice(0, 10);
}

// Deterministic (stable) IDs
export function makeMenuComponentId(level: number, kind: string, seed: string) {
    return `menu-component-level-${level}-${kind}-${hash10(kind + '|' + level + '|' + seed)}`;
}

export function makeBaseComponentId(kind: string, seed: string) {
    return `component-${kind}-${hash10(kind + '|' + seed)}`;
}